// this file added by Bearer Web Developer
function scaleBounds(bounds : google.maps.LatLngBounds, scale : number = 0.9) {
  const ne = bounds.getNorthEast();
  const sw = bounds.getSouthWest();

  const latDiff = ne.lat() - sw.lat();
  const lngDiff = ne.lng() - sw.lng();

  const newLatDiff = latDiff / scale; // make more bounds 
  const newLngDiff = lngDiff / scale;

  const centerLat = sw.lat() + latDiff / 2;
  const centerLng = sw.lng() + lngDiff / 2;

  return new google.maps.LatLngBounds(
    new google.maps.LatLng(centerLat - newLatDiff / 2, centerLng - newLngDiff / 2),
    new google.maps.LatLng(centerLat + newLatDiff / 2, centerLng + newLngDiff / 2)
  );
}
export default scaleBounds;